
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";

interface VerseTextProps {
  text: string;
  reference: string;
  version?: string;
}

const BIBLE_VERSION_NAMES: Record<string, string> = {
  'KJV': 'King James Version',
  'NASB': 'New American Standard Bible',
  '9879dbb7cfe39e4d-01': 'World English Bible'
};

export function VerseText({ text, reference, version = "KJV" }: VerseTextProps) {
  const [error, setError] = useState<string | null>(null);

  // Remove any numbers from the beginning of the verse text, paragraph symbols, and ALL types of quotes
  const cleanText = text
    .replace(/^\d+\s*/, '')                    // Remove leading numbers
    .replace(/¶/g, '')                         // Remove paragraph symbols
    .replace(/["'"'""]/g, '')                  // Remove basic quotes
    .replace(/[`′″‟„""]/g, '')                 // Remove other quote-like characters
    .replace(/[\u2018-\u201F]/g, '')           // Remove Unicode quote ranges
    .replace(/[\u201C-\u201D]/g, '')           // Remove specific Unicode quotes
    .replace(/["""]/g, '')                     // Extra pass for double quotes
    .replace(/['′‵՚ꞌ᾽᾿']/g, '')                // Extra pass for single quotes
    .replace(/^["']|["']$/g, '')               // Remove quotes at start/end
    .replace(/\s["']/g, ' ')                   // Remove quotes after spaces
    .replace(/["']\s/g, ' ')                   // Remove quotes before spaces
    .trim();
  
  return (
    <div className="space-y-6">
      <p className="text-2xl font-verse text-white leading-relaxed px-4">
        {cleanText}
      </p>
      <div className="flex flex-col gap-3 px-4">
        {error && (
          <p className="text-sm text-red-400">{error}</p>
        )}
        <div className="flex flex-col">
          <p className="text-lg font-verse text-white font-semibold">
            - {reference}
          </p>
          <span className="text-sm text-white/80 mt-1">
            {BIBLE_VERSION_NAMES[version] || version}
          </span>
        </div>
      </div>
    </div>
  );
}
